import  { useState, useEffect } from "react";
import { Select } from "antd";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import UserCreatedModal from "../components/UserCreatedModal";
import { useGetUserProfileQuery, useCreateUserMutation, useGetDownlineByTypeQuery, useGetUserByIdQuery } from "../services/auth/authApi";
import { useGetAppUrlsQuery } from "../services/user/userApi";
import { getDomainAppUrl } from "../utils/domainConfig";

// Import all form components
import SuperAdminForm from "../components/forms/SuperAdminForm";
import MiniAdminForm from "../components/forms/MiniAdminForm";
import MasterForm from "../components/forms/MasterForm";
import SuperForm from "../components/forms/SuperForm";
import AgentForm from "../components/forms/AgentForm";
import ClientForm from "../components/forms/ClientForm";

// User type constants
export const USER_TYPES = {
  'Admin': 1,
  'SuperAdmin': 2,
  'MiniAdmin': 3,
  'Master': 4,
  'Super': 5,
  'Agent': 6,
  'Client': 7,
};

export const USER_TYPE_NAMES = {
  1: "Admin",
  2: "SuperAdmin",
  3: "MiniAdmin",
  4: "Master",
  5: "Super",
  6: "Agent",
  7: "Client",
};

// Down Arrow Icon

const CreateUserPage = () => {
  const navigate = useNavigate();
  const { userType: userTypeParam } = useParams();
  const getUserType = localStorage.getItem("user_data");
  const currentUser = getUserType ? JSON.parse(getUserType) : null;
  // console.log("Current user from localStorage:", currentUser);
  
  // Get user profile data from API
  const { data: userProfileData, isLoading: profileLoading, error: profileError } = useGetUserProfileQuery();
  
  // Get current user ID from localStorage
  const getCurrentUserId = () => {
    try {
      const userData = JSON.parse(getUserType);
      return userData?.id || userData?.userId || userData?._id;
    } catch (error) {
      console.error('Error getting user ID:', error);
      return null;
    }
  };
  
  // Create user mutation
  const [createUser, { isLoading: createUserLoading }] = useCreateUserMutation();  // Map URL param to user type
  const userTypeMap = {
    admin: USER_TYPES.Admin,
    superadmin: USER_TYPES.SuperAdmin,
    "super-admin": USER_TYPES.SuperAdmin,
    miniadmin: USER_TYPES.MiniAdmin,
    "mini-admin": USER_TYPES.MiniAdmin,
    master: USER_TYPES.Master,
    super: USER_TYPES.Super,
    "super-master": USER_TYPES.Super,
    supermaster: USER_TYPES.Super,
    agent: USER_TYPES.Agent,
    client: USER_TYPES.Client,
  };

  const targetUserType =
    userTypeMap[userTypeParam?.toLowerCase()] || USER_TYPES.MiniAdmin;
  const userTypeName = USER_TYPE_NAMES[targetUserType] || "User";
  const isClient = targetUserType === USER_TYPES.Client;

  // App URLs — sirf SuperAdmin create pe. Form me "App URL" dropdown (guru99admin jaisa): SuperAdmin kis
  // domain ka hai, uski poori downline usi domain pe login karti hai. Default = current domain wala AppUrl.
  const isSuperAdmin = targetUserType === USER_TYPES.SuperAdmin;
  const { data: appUrlsData } = useGetAppUrlsQuery(undefined, { skip: !isSuperAdmin });
  const appUrlList = isSuperAdmin ? (appUrlsData?.data || (Array.isArray(appUrlsData) ? appUrlsData : [])) : [];
  const matchedAppUrl = appUrlList.find((a) => a.url === getDomainAppUrl()) || null;

  // Get current user type from localStorage
  const getCurrentUserType = () => {
    try {
      const userData = JSON.parse(getUserType);
      if (userData?.hierarchyLevel) {
        return userData.hierarchyLevel;
      }
    } catch (error) {
      console.error('Error parsing user data:', error);
    }
    
    // Fallback to API data
    if (userProfileData?.user?.hierarchyLevel) {
      return userProfileData.user.hierarchyLevel;
    }
    
    return USER_TYPES.Admin; // Default
  };

  const currentUserType = getCurrentUserType();
  const levelDifference = Math.abs(currentUserType - targetUserType);
  const needsUplineSelection = levelDifference > 1;

  // Get parent user type (one level above the target user)
  const parentUserType = targetUserType - 1;
  const parentUserTypeName = USER_TYPE_NAMES[parentUserType] || "User";

  // Get downline by type using RTK Query - send the parent user type
  const { data: downlineData, isLoading: loadingUpline, error: downlineError } = useGetDownlineByTypeQuery(
    parentUserTypeName,
    { skip: !needsUplineSelection }
  );

  // State management
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [successModal, setSuccessModal] = useState({
    isOpen: false,
    userId: null,
    password: null,
    loginDomain: null,
  });

  // Upline selection state
  const [uplineList, setUplineList] = useState([]);
  const [selectedUpline, setSelectedUpline] = useState(null);
  const [selectedUplineId, setSelectedUplineId] = useState(null);
  const [parentDetails, setParentDetails] = useState(null);

  // Get user details by ID using RTK Query (for selected upline)
  const { data: userDetailsData, isLoading: loadingDetails } = useGetUserByIdQuery(
    selectedUplineId,
    { skip: !selectedUplineId }
  );
  
  // Get current user details from hierarchy API when no upline is selected
  const currentUserId = getCurrentUserId();
  const { data: currentUserDetailsData, isLoading: loadingCurrentUser } = useGetUserByIdQuery(
    currentUserId,
    { skip: !currentUserId || needsUplineSelection }
  );

  // Update upline list when data is fetched
  useEffect(() => {
    if (downlineData?.data) {
      // Use the downline users directly (not parent data)
      setUplineList(downlineData.data);
    } else if (downlineError) {
      setError("Failed to load upline users");
      setUplineList([]);
    }
  }, [downlineData, downlineError]);

  // Form data
  const [formData, setFormData] = useState({
    userType: userTypeName, // Use the correct userTypeName from URL
    fullName: "",
    contactNo: "",
    myShare: "",
    companyShare: "",
    matchCommission: "",
    sessionCommission: "",
    casinoShare: "",
    companyCasinoShare: "",
    casinoCommission: "",
    matkaCommission: "",
    exposureLimit: "",
    shareType: "fixed",
    commType: "Bet by bet",
    reference: "",
    appUrl: "", // khaali = current domain wala (matchedAppUrl)
  });

 



 



  // Handle form field changes
  // chuna hua AppUrl — user ne dropdown se chuna, warna current domain wala
  const selectedAppUrlId = formData.appUrl || matchedAppUrl?._id || "";
  const selectedAppUrl = appUrlList.find((a) => a._id === selectedAppUrlId) || null;

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  // Prevent scroll from changing number input values
  const handleNumberWheel = (e) => {
    e.target.blur();
  };

  // Handle toggle for switches
  const handleToggle = (name) => {
    setFormData((prev) => ({
      ...prev,
      [name]: !prev[name],
    }));
  };

  // Update parent details when user details are fetched (selected upline)
  useEffect(() => {
    if (userDetailsData?.data) {
      // console.log('Setting parentDetails from selected upline API:', userDetailsData.data);
      
      setParentDetails(userDetailsData.data);
    }
  }, [userDetailsData]);

  // Set parent details from current user hierarchy data when not selecting upline
  useEffect(() => {
    if (!needsUplineSelection && currentUserDetailsData?.data) {
      // console.log('Setting parentDetails from current user hierarchy API:', currentUserDetailsData.data);
      setParentDetails(currentUserDetailsData.data);
    }
  }, [needsUplineSelection, currentUserDetailsData]);



  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setSuccess(null);

    try {
      // Validate match share against parent
      const matchShare = parseFloat(formData.myShare);
      const parentMatchShare = parseFloat(parentDetails?.shares?.myShare);
      
      if (!isNaN(matchShare) && !isNaN(parentMatchShare) && matchShare > parentMatchShare) {
        toast.error(`Match Share(%) cannot be greater than parent's match share(%) (${parentMatchShare}%)`);
        setLoading(false);
        return;
      }
      const payload = {
        name: formData.fullName,
        shareType: userTypeName,
        userType: userTypeName, // Use the correct userTypeName from URL
        coins: parseFloat(formData.exposureLimit) || 0,
        contactNumber: formData.contactNo,
        matchShare: parseFloat(formData.myShare) || 0,
        commissionType: formData.commType,
        matchCommission: parseFloat(formData.matchCommission) || 0,
        sessionCommission: parseFloat(formData.sessionCommission) || 0,
        casinoShare: parseFloat(formData.casinoShare) || 0,
        casinoCommission: parseFloat(formData.casinoCommission) || 0,
        matkaCommission: parseFloat(formData.matkaCommission) || 0,
        parentId: selectedUpline?.id || selectedUpline?._id || selectedUpline?.userId || userProfileData?.user?.id || "",
        reference: formData.reference || "",
        ...(isSuperAdmin && selectedAppUrlId ? { appUrl: selectedAppUrlId } : {}),
      };
      const response = await createUser(payload);

      // Check if the response is successful
      if (response?.data?.success) {
        // Show success modal with userId and password from response
        setSuccessModal({
          isOpen: true,
          userId: response.data.data.userId,
          password: response.data.data.password || response.data.password,
          loginDomain: selectedAppUrl?.url || null,
        });
        setSuccess(response.data.message || "User created successfully!");
      } else if (response?.error) {
        // Handle error from RTK Query
        setError(
          response.error?.data?.message || response.error.message || "Failed to create user"
        );
      }
    } catch (err) {
      setError(
        err.response?.data?.message || err.message || "An error occurred while creating user",
      );
    } finally {
      setLoading(false);
    }
  };

  // Render appropriate form component based on user type
  const renderFormComponent = () => {
    
    const commonProps = {
      formData,
      handleChange,
      handleNumberWheel,
      handleSubmit,
      loading,
      createUserLoading,
      error,
      userProfileData,
      parentDetails,
    };

    switch (targetUserType) {
      case USER_TYPES.SuperAdmin:
        console.log('🟡 Rendering SuperAdminForm');
        return <SuperAdminForm {...commonProps} appUrls={appUrlList} appUrlValue={selectedAppUrlId} />;
      case USER_TYPES.MiniAdmin:
        console.log('🟡 Rendering MiniAdminForm');
        return <MiniAdminForm {...commonProps} />;
      case USER_TYPES.Master:
        console.log('🟡 Rendering MasterForm');
        return <MasterForm {...commonProps} />;
      case USER_TYPES.Super:
        console.log('🟡 Rendering SuperForm');
        return <SuperForm {...commonProps} />;
      case USER_TYPES.Agent:
        console.log('🟡 Rendering AgentForm');
        return <AgentForm {...commonProps} />;
      case USER_TYPES.Client:
        console.log('🟡 Rendering ClientForm');
        return <ClientForm {...commonProps} />;
      default:
        console.log('🟡 Rendering MiniAdminForm (default)');
        return <MiniAdminForm {...commonProps} />; // Default fallback
    }
  };

  const inputClass =
    "w-full border border-gray-300 px-3 py-2 focus:outline-none focus:border-blue-500 [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none";
  const labelClass = "block text-gray-700 text-sm mb-1";
  const disabledInputClass =
    "w-full border border-gray-300 px-3 py-2 bg-gray-100 text-gray-700 cursor-not-allowed";

  // Show loading while fetching user profile
  if (profileLoading) {
    return (
      <div className="w-full flex justify-center items-center min-h-[400px]">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Loading user profile...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full">
      <div className="max-w-5xl mx-auto px-2 py-4">
        {/* Upline Selection Card (if needed) */}
        {needsUplineSelection && (
          <div className="bg-white rounded shadow border border-gray-200 mb-4">
            <div className="bg-gray-600 px-5 py-3">
              <div className="text-xl text-white text-center">
                Select Upline
              </div>
            </div>
            <div className="px-5 py-4 flex justify-center">
              <Select
                showSearch
                style={{ width: 300 }}
                placeholder="Select a person"
                loading={loadingUpline}
                disabled={loadingUpline}
                value={(selectedUpline?.id || selectedUpline?._id || selectedUpline?.userId) || undefined}
                optionFilterProp="label"
                options={uplineList.map(u => ({
                  value: u.id || u._id || u.userId,
                  label: `${u.username} (${u.fullname || u.name || ''})`,
                }))}
                onChange={(val) => {
                  const user = uplineList.find(u => (u.id || u._id || u.userId) === val) || null;
                  setSelectedUpline(user);
                  setSelectedUplineId(val || null);
                }}
              />
            </div>
          </div>
        )}

        {/* Show form only if upline is selected OR if creating directly under self */}
        {((needsUplineSelection && selectedUpline) ||
          !needsUplineSelection) && (
          <div className="bg-white rounded shadow border border-gray-200">
            {/* Header */}
            <div className="bg-gray-600 px-5 py-3 flex items-center justify-between">
              <span className="text-2xl text-white font-normal capitalize">
                Create {userTypeName.toLowerCase()}
              </span>
              <button
                onClick={() => navigate(-1)}
                className="bg-blue-500 text-white px-4 py-2 hover:bg-blue-600"
                type="button"
              >
                Back
              </button>
            </div>

            {/* Loading state for parent details */}
            {loadingDetails && (
              <div className="p-4 text-center text-gray-500">
                Loading parent details...
              </div>
            )}

            {/* Form – using separate components based on user type */}
            {renderFormComponent()}
          </div>
        )}
      </div>
      <UserCreatedModal
        isOpen={successModal.isOpen}
        onClose={() => {
          setSuccessModal({ isOpen: false, userId: null, password: null, loginDomain: null });
          navigate(-1);
        }}
        userId={successModal.userId}
        password={successModal.password}
        userType={userTypeName}
        isClient={isClient}
        loginDomain={successModal.loginDomain}
      />
    </div>
  );
};

export default CreateUserPage;
